import { useState, useEffect } from 'react';
import { getHighscores } from '../utils/scores';
import { useTranslation } from 'react-i18next';

export const Highscores = ({ refreshTrigger, className='' }) => {
    const { t } = useTranslation();
    const [scores, setScores] = useState([]);
    const [loading, setLoading] = useState(true);
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        const loadScores = async () => {
            setLoading(true);
            const highscores = await getHighscores(true);
            setScores(highscores);
            setLoading(false);
        };
        loadScores();
    }, [refreshTrigger]);

    return (
        <div className={`bg-white px-4 py-2 sm:py-3 rounded-lg shadow-sm overflow-y-scroll ${className}`}>
            <style>{`
                .highscores-wrapper {
                    opacity: 0;
                    transform: translateY(10px);
                    transition: opacity 0.3s ease-out, transform 0.3s ease-out;
                }
                .highscores-wrapper.mounted {
                    opacity: 1;
                    transform: translateY(0);
                }
                .scores-container {
                    transition: max-height 0.3s ease-in-out, opacity 0.3s ease-in-out;
                    max-height: 500px;
                    opacity: 1;
                }
                .scores-container.loading {
                    max-height: 50px;
                    opacity: 0.7;
                }
                .score-item {
                    transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
                }
            `}</style>
            <div className={`highscores-wrapper ${mounted ? 'mounted' : ''}`}>
                <h4 className="font-semibold mb-2 sm:mb-4 border-b border-stone-200">
                    {t('game.gameOver.topBakers')}
                </h4>
                <div className={`scores-container ${loading ? 'loading' : ''}`}>
                    {loading ? (
                        <p className="text-center text-stone-500 italic">{t('game.gameOver.loadingScores')}</p>
                    ) : (
                        <div className="space-y-2">
                            <div className="grid text-sm text-stone-500 mb-1 py-0"
                                style={{ gridTemplateColumns: 'minmax(40px, auto) minmax(30px, 1fr) minmax(40px, auto) minmax(75px, auto)' }}>
                                <div className="text-left pr-2">{t('game.gameOver.rank')}</div>
                                <div className="text-left pr-2">{t('game.gameOver.name')}</div>
                                <div className="text-right pl-2">{t('game.gameOver.days')}</div>
                                <div className="text-right pr-2">{t('game.gameOver.result')}</div>
                            </div>
                            {scores.map((score, index) => (
                                <div
                                    key={score.id}
                                    className="score-item grid items-center py-0"
                                    style={{ gridTemplateColumns: 'minmax(40px, auto) minmax(30px, 1fr) minmax(40px, auto) minmax(75px, auto)' }}>
                                    <div className="text-left pr-2">{index + 1}</div>
                                    <div className="text-left pr-2 truncate">{score.playerName}</div>
                                    <div className="text-right pl-2">{score.daysSurvived}</div>
                                    <div className="text-right pr-2">{t('game.currency', {amount: Math.abs(score.moneyEarned)})}</div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};


export const SubmissionOverlay = ({ status, message }) => {
    const statusStyles = {
      success: 'border-2 border-emerald-500 bg-emerald-50 text-stone-900',
      'score-updated': 'border-2 border-emerald-500 bg-emerald-50 text-stone-900',
      'lower-score': 'border-2 border-yellow-400 bg-amber-50 text-stone-900',
      error: 'border-2 border-rose-500 bg-rose-50 text-stone-900',
      default: 'border-2 border-yellow-400 bg-amber-50 text-stone-900',
    };
  
    return (
        <div className="absolute z-50 bottom-8 left-0 right-0 flex justify-center">
            <div className={`text-sm max-w-[250px] p-3 animate-tooltip-enter rounded-lg shadow-md ${statusStyles[status] || statusStyles.default}`}>
                {message}
            </div>
        </div>
    );
};